import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  containerClass?: string;
}
export const Section = ({
  children,
  className = '',
  id,
  containerClass = 'max-w-4xl mx-auto'
}: SectionProps) => {
  return <section id={id} className={`py-16 md:py-24 px-5 md:px-8 ${className}`} data-id="element-179">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className={containerClass} data-id="element-180">
        {children}
      </motion.div>
    </section>;
};